"use client";

import Image from "next/image";
import { ComponentProps, CSSProperties, FC, useState } from "react";
import { FaQuestionCircle } from "react-icons/fa";

interface SalifyImageProps extends Omit<ComponentProps<typeof Image>, "src" | "alt"> {
  src: string | undefined;
  alt?: string;
}

export const SalifyImage: FC<SalifyImageProps> = ({ src, alt, style, ...props }) => {
  const [imgError, setImgError] = useState(false);
  const mergedStyle: CSSProperties = {
    objectFit: "cover" as const,
    ...style,
  };
  const hasExplicitSize = props.fill || (props.width != null && props.height != null);
  const safeProps = hasExplicitSize ? props : { ...props, width: 64, height: 64 };

  return !imgError ? (
    <Image
      src={src ?? ""}
      alt={alt ?? ""}
      style={mergedStyle}
      {...safeProps}
      onError={() => setImgError(true)}
    />
  ) : (
    <FaQuestionCircle size={40} color="gray" />
  );
};
